import {Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";

@Component({
  selector: 'app-doc-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './doc-edit.component.html',
  styleUrl: './doc-edit.component.scss'
})
export class DocEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected crudService: CrudService) {

  }

  editLink = '/dashboard/doc-edit/';
  menuLink = '/dashboard/doc';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'doc';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {
        settings: {},
      } as any;
    }
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New doc)',
        configs: [
          {field: 'label_en', name: 'Label En', type: EInputType.TEXT, validators: []},
          {field: 'label_es', name: 'Label Es', type: EInputType.TEXT, validators: []},
          {field: 'order', name: 'Order', type: EInputType.TEXT, validators: []},
          {field: 'file_en', name: 'File En', type: EInputType.FILE, validators: []},
          {field: 'file_es', name: 'File Es', type: EInputType.FILE, validators: []},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (doc ' + item.id + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
